import { render, staticRenderFns } from "./accounts.vue?vue&type=template&id=39852588&scoped=true"
import script from "./accounts.vue?vue&type=script&lang=js"
export * from "./accounts.vue?vue&type=script&lang=js"
import style0 from "./accounts.vue?vue&type=style&index=0&id=39852588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39852588",
  null
  
)

export default component.exports